import auditedMouths from '../data/portrait-mouths.mjs';
import corrections from '../data/portrait-corrections.mjs';

// Enrich the legacy three-trait API without changing its records or overriding
// a mouth supplied by the API. Only the exact audited portrait is eligible.
export function withPortraitTraits(infos) {
  return Object.fromEntries(Object.entries(infos).map(([id, info]) => {
    const audited = auditedMouths[id];
    const enriched = !info.mouth && audited?.url === info.url
      ? { ...info, mouth: audited.mouth }
      : { ...info };
    const correction = corrections[id];
    if (correction?.url === info.url) {
      for (const [trait, value] of Object.entries(correction.traits)) {
        // Only replace the known legacy error, not a newer API classification.
        if (info[trait] === correction.from[trait]) enriched[trait] = value;
      }
    }
    return [id, enriched];
  }));
}
